<div class="details-layout">
  <ng-template [ngTemplateOutlet]="topBar()"></ng-template>
  <mat-tab-group
    [selectedIndex]="selectedTabIndex()"
    (selectedTabChange)="changeTab.emit($event.tab.textLabel)"
  >
    @if (hasOverview()) {
      <mat-tab label="Overview">
        <ng-template mat-tab-label>
          <mat-icon color="accent">dashboard</mat-icon>
          Overview
        </ng-template>
        <ng-template matTabContent>
          <ng-template [ngTemplateOutlet]="overview()"></ng-template>
        </ng-template>
      </mat-tab>
    }
    @if (hasManage()) {
      <mat-tab label="Manage">
        <ng-template mat-tab-label>
          <mat-icon color="accent">dns</mat-icon>
          Manage
        </ng-template>
        <ng-template matTabContent>
          <ng-template [ngTemplateOutlet]="manage()"></ng-template>
        </ng-template>
      </mat-tab>
    }
    @if (hasConfig()) {
      <mat-tab label="Configuration">
        <ng-template mat-tab-label>
          <mat-icon color="accent">perm_data_setting</mat-icon>
          Telemetry
        </ng-template>
        <ng-template matTabContent>
          <ng-template [ngTemplateOutlet]="configuration()"></ng-template>
        </ng-template>
      </mat-tab>
    }
    @if (hasHistory()) {
      <mat-tab [label]="historyTabLabel()">
        <ng-template mat-tab-label>
          <mat-icon color="accent">history</mat-icon>
          {{ historyTabLabel() }}
        </ng-template>
        <ng-template matTabContent>
          <ng-template [ngTemplateOutlet]="orderHistory()"></ng-template>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</div>
